<template>
  <div>
    <h3>{{ $t('Filter by Fuel Type') }}</h3>

    <div class="afdc-form-group">
      <div v-for="option in fuelOptions" v-bind:key="option.key">
        <div class="afdc-custom-control afdc-custom-checkbox">
          <input type="checkbox" class="afdc-custom-control-input" v-bind:value="option.key" v-model="queryFuel" v-bind:id="'afdc-analyze-fuel-' + option.key">
          <label class="afdc-custom-control-label" v-bind:for="'afdc-analyze-fuel-' + option.key">{{ option.name }}</label>
        </div>
        <template v-if="option.key !== 'all'">
          <component v-bind:is="`analyze-fuel-filters-${option.key.toLowerCase()}`" v-show="queryFuel && queryFuel.includes(option.key)" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AnalyzeFuelFiltersBd from '@/components/AnalyzeFuelFiltersBd.vue';
import AnalyzeFuelFiltersRd from '@/components/AnalyzeFuelFiltersRd.vue';
import AnalyzeFuelFiltersCng from '@/components/AnalyzeFuelFiltersCng.vue';
import AnalyzeFuelFiltersE85 from '@/components/AnalyzeFuelFiltersE85.vue';
import AnalyzeFuelFiltersElec from '@/components/AnalyzeFuelFiltersElec.vue';
import AnalyzeFuelFiltersHy from '@/components/AnalyzeFuelFiltersHy.vue';
import AnalyzeFuelFiltersLng from '@/components/AnalyzeFuelFiltersLng.vue';
import AnalyzeFuelFiltersLpg from '@/components/AnalyzeFuelFiltersLpg.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  components: {
    AnalyzeFuelFiltersBd,
    AnalyzeFuelFiltersRd,
    AnalyzeFuelFiltersCng,
    AnalyzeFuelFiltersE85,
    AnalyzeFuelFiltersElec,
    AnalyzeFuelFiltersHy,
    AnalyzeFuelFiltersLng,
    AnalyzeFuelFiltersLpg,
  },

  computed: {
    fuelOptions() {
      return this.$store.getters.loaderFuels;
    },

    queryFuel: syncInputRouteQuery('fuel'),
  },
};
</script>

<style lang="scss">
.fuel-filters-box {
  background-color: #bbb;
  padding: 10px 10px 1px 10px;
  margin-bottom: 15px;
}
</style>
